import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {
    Page,
    Preload,
} from '../components'
import '../styles/giftcard/GiftCard.css'
import {renderMoney} from '../utils';
import qs from 'qs'
import giftImg from '../images/gift.jpg';

class GiftCardSharePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false,
            account: '',
            gift: '',
            targetInfo: '',
            subGift: '',
        };

        this.initComponent = this.initComponent.bind(this);
    }

    componentDidMount() {
        let params = this.props.params
        let giftShareType = params.type
        let giftShareId = params.gift_card_share_id

        axios.get('/api/gift/info', {
            params: {
                type: giftShareType,
                gift_id: giftShareId
            }
        }).then(response => {
            if (response.data.code === 0) {
                const {account, gift, target_info, sub_gift, share_info} = response.data.data
                this.setState({
                    account: account,
                    gift: gift,
                    targetInfo: target_info,
                    subGift: sub_gift,
                    initialized: true,
                });

                this.initComponent(share_info)
            }
        });
    }

    initComponent(share_info) {
        let params = this.props.params
        let type = params.type
        let id = params.gift_card_share_id

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url,
                successCallback: function() {
                    let data = {type, gift_id: id};
                    axios.post(`/api/gift/share`, qs.stringify(data)).then(res => {})
                }
            }
        });
    }

    render() {
        const {initialized, gift, targetInfo, account} = this.state;
        if (!initialized) {
            return <Preload />
        }
        return (
            <Page className="gift-card-share-page">
                <div className="gift-card-all-div">
                    <div className="gift-card">
                        <div className="gift-card-top">
                            <img src={giftImg} alt="礼物图片"/>
                            <div className="gift-card-describe">
                                <div className="gift-card-describe-title">{account.nickname}买单请你免费听</div>
                                <div>¥{renderMoney(gift.price)}</div>
                            </div>
                            <div className="gift-card-number">1份</div>
                        </div>
                        <div className="bottom-info">
                            <div className="bottom-big-title">{targetInfo.name}</div>
                            <div>{targetInfo.liveroom_name}</div>
                        </div>
                    </div>
                    <div className="gift-card-second-page-div">
                        <span>点击右上角</span>
                        <span>将礼券赠送给好友</span>
                    </div>
                </div>
            </Page>
        );
    }
}

export default connect(state => ({}))(GiftCardSharePage)


// WEBPACK FOOTER //
// ./src/pages/GiftCardSharePage.js